<!-- 风柜参数详情 -->
<template>
  <div class="scheme-detail-box">
    <cmp-drawer :show="show" :title="title" @onClose="handleClose" @submit="hanleSubmit">
        <div>
            <p class="meter-title">基本信息</p>
            <el-row :gutter="5">
                <el-col :span="6"><span>业主名称：</span><span>{{modelData.householdname}}</span></el-col>
                <el-col :span="6"><span>房间号：</span><span>{{modelData.housename}}</span></el-col>
                <el-col :span="6"><span>表计序列号：</span><span>{{modelData.deviceSerial}}</span></el-col>
                <el-col :span="6"><span>在线状态：</span><span>{{fmtOnlineStatus(modelData.status)}}</span></el-col>
            </el-row>
            <p class="meter-title">风柜运行状态</p>
            <el-row :gutter="5">
                <el-col :span="6"><span>运行状态：</span><span>{{modelData.isRunning}}</span></el-col>
                <el-col :span="6"><span>故障状态：</span><span>{{modelData.sysStatusResult}}</span></el-col>
                <el-col :span="6"><span>通讯状态：</span><span>{{modelData.linkStatus}}</span></el-col>
                <el-col :span="6"><span>计量状态：</span><span>{{modelData.inCounting}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="6"><span>供冷/供热：</span><span>{{modelData.modeStatus}}</span></el-col>
                <el-col :span="6"><span>余额状态：</span><span>{{modelData.balanceAlarm}}</span></el-col>
                <el-col :span="6"><span>计费状态：</span><span>{{modelData.allowCharging}}</span></el-col>
                <el-col :span="6"><span>模式：</span><span>{{modelData.factoryMode}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="24"><span>累计读数：</span><span>{{modelData.counterTotal}}</span></el-col>
            </el-row>
            <p class="meter-title">风柜参数值</p>
            <el-row :gutter="5">
                <el-col :span="6"><span>温度传感器温度：</span><span>{{modelData.tsensorValue/10 + '℃'}}</span></el-col>
                <el-col :span="6"><span>湿度传感器湿度：</span><span>{{modelData.hsensorValue/10 + '℃'}}</span></el-col>
                <el-col :span="6"><span>外环境传感器温度：</span><span>{{modelData.extsensorValue/10 + '℃'}}</span></el-col>
                <el-col :span="6"><span>静压传感器压力：</span><span>{{modelData.psensorValue + 'Pa'}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="6"><span>水阀输出开度：</span><span>{{modelData.waterValveAperture + '%'}}</span></el-col>
                <el-col :span="6"><span>开关量加湿阀状态：</span><span>{{modelData.humidifierOn}}</span></el-col>
                <el-col :span="6"><span>比例加湿阀：</span><span>{{modelData.humidifierAperture}}</span></el-col>
                <el-col :span="6"><span>风机运行状态：</span><span>{{modelData.fanMotorOn}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="8"><span>变频风机输出频率：</span><span>{{modelData.vffanFreq/10 + 'Hz'}}</span></el-col>
                <el-col :span="8"><span>浮点新风阀输出开度：</span><span>{{modelData.fauAperture}}</span></el-col>
                <el-col :span="8"><span>开关量新风阀输出状态：</span><span>{{modelData.fauOn}}</span></el-col>
            </el-row>
            <p class="meter-title">风柜的计量参数</p>
            <el-row :gutter="5">
                <el-col :span="6"><span>当月费用：</span><span>{{baseData.monthly_fee_int + '元'}}</span></el-col>
                <el-col :span="6"><span>当前余额：</span><span>{{baseData.current_balance_int + '元'}}</span></el-col>
                <el-col :span="6"><span>费用查询设定：</span><span>{{fmtStr_0_1(baseData.allow_query, '不可查询','可查询')}}</span></el-col>
                <el-col :span="6"><span>通讯中断判定时间：</span><span>{{baseData.link_down_threshold + 'min'}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="12"><span>风机电功率：</span><span>{{baseData.fcu_motor_power + 'W'}}</span></el-col>
                <el-col :span="12"><span>风柜换热量：</span><span>{{baseData.swap_capacity + 'KW'}}</span></el-col>
            </el-row>
            <p class="meter-title">风柜的运行参数</p>
            <el-row :gutter="5">
                <el-col :span="8"><span>开关机：</span><span>{{funFmtWKQParmas(baseData.setting_power_on).powerOn()}}</span></el-col>
                <el-col :span="8"><span>模式：</span><span>{{funFmtWKQParmas(baseData.setting_mode).settingMode()}}</span></el-col>
                <el-col :span="8"><span>通风模式使能：</span><span>{{funFmtWKQParmas(baseData.setting_allow_ventilation).setting_enable_fanonly()}}</span></el-col>
            </el-row>
            <p class="meter-line"></p>
            <el-row :gutter="5">
                <el-col :span="6"><span>制冷温度设定：</span><span>{{baseData.setting_cooling_temperature/10 + '℃'}}</span></el-col>
                <el-col :span="6"><span>制热温度设定：</span><span>{{baseData.setting_heating_temperature/10 + '℃'}}</span></el-col>
                <el-col :span="6"><span>温度设定上限：</span><span>{{baseData.setting_temperature_ul + '℃'}}</span></el-col>
                <el-col :span="6"><span>温度设定下限：</span><span>{{baseData.setting_temperature_dl + '℃'}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="8"><span>湿度设定：</span><span>{{baseData.setting_humidity/10 + '%'}}</span></el-col>
                <el-col :span="8"><span>湿度上限设定：</span><span>{{baseData.setting_humidity_ul + '%'}}</span></el-col>
                <el-col :span="8"><span>湿度下限设定：</span><span>{{baseData.setting_humidity_dl + '%'}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="8"><span>静压设定：</span><span>{{baseData.setting_static_pressure + 'Pa'}}</span></el-col>
                <el-col :span="8"><span>静压设定上限：</span><span>{{baseData.setting_static_pressure_ul + 'Pa'}}</span></el-col>
                <el-col :span="8"><span>静压设定下限：</span><span>{{baseData.setting_static_pressure_dl + 'Pa'}}</span></el-col>
            </el-row>
            <p class="meter-line"></p>
            <el-row :gutter="5">
                <el-col :span="12"><span>键盘锁定：</span><span>{{funFmtWKQParmas(baseData.setting_key_lock).setting_key_lock()}}</span></el-col>
                <el-col :span="12"><span>来电启动方式：</span><span>{{funFmtWKQParmas(baseData.setting_op_at_acback).setting_op_at_acback()}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="6"><span>温度传感器量程：</span><span>{{baseData.setting_tsensor_range+ '℃'}}</span></el-col>
                <el-col :span="6"><span>湿度传感器配置：</span><span>{{fmtStr_0_1(baseData.setting_has_hsensor, '无' , '有')}}</span></el-col>
                <el-col :span="6"><span>湿度传感器量程：</span><span>{{baseData.setting_hsensor_range + '%'}}</span></el-col>
                <el-col :span="6"><span>外环境传感器配置：</span><span>{{fmtStr_0_1(baseData.setting_has_ext_tsensor, '无' , '有')}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="6"><span>外环境传感器量程：</span><span>{{baseData.setting_ext_tsensor_range + '℃'}}</span></el-col>
                <el-col :span="6"><span>静压传感器配置：</span><span>{{fmtStr_0_1(baseData.setting_has_psensor, '无' , '有')}}</span></el-col>
                <el-col :span="6"><span>静压传感器量程：</span><span>{{baseData.setting_wv_type + 'Pa'}}</span></el-col>
                <el-col :span="6"><span>水阀类型配置：</span><span>{{fmtStr_1_2(baseData.setting_has_ext_tsensor, '比例调节阀', '浮点调节阀')}}</span></el-col>
            </el-row>
            <p class="meter-line"></p>
            <el-row :gutter="5">
                <el-col :span="8"><span>浮点调节阀行程设定：</span><span>{{baseData.setting_fwv_distance + 's'}}</span></el-col>
                <el-col :span="8"><span>水阀Kp系数：</span><span>{{baseData.setting_wv_Kp}}</span></el-col>
                <el-col :span="8"><span>水阀Ki系数：</span><span>{{baseData.setting_wv_Ki/10}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="6"><span>水阀调节死区：</span><span>{{baseData.setting_wv_dz/10 + '℃'}}</span></el-col>
                <el-col :span="6"><span>水阀调节输出周期：</span><span>{{baseData.setting_wv_period + 's'}}</span></el-col>
                <el-col :span="6"><span>水阀开度设定：</span><span>{{baseData.setting_wv_offaperture + '%'}}</span></el-col>
                <el-col :span="6"><span>湿度控制设定：</span><span>{{fmtStr_0_1(baseData.setting_has_humidity_ctrl, '无', '有')}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="8"><span>加湿阀类型配置：</span><span>{{fmtStr_0_1(baseData.setting_humidifier_type, '比例调节控制', '开关量控制')}}</span></el-col>
                <el-col :span="8"><span>比例加湿阀Kp系数：</span><span>{{baseData.setting_humidifier_Kp}}</span></el-col>
                <el-col :span="8"><span>比例加湿阀Ki系数：</span><span>{{baseData.setting_humidifier_Ki/10}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="6"><span>比例加湿阀调节死区：</span><span>{{baseData.setting_humidifier_dz+ '%'}}</span></el-col>
                <el-col :span="6"><span>比例加湿阀调节输出周期：</span><span>{{baseData.setting_humidifier_period + 's'}}</span></el-col>
                <el-col :span="6"><span>变频风机控制设定：</span><span>{{fmtStr_0_1(baseData.setting_vffan_en, '不控制', '变频控制')}}</span></el-col>
                <el-col :span="6"><span>变频风机频率下限：</span><span>{{baseData.setting_vffan_dfl + 'Hz'}}</span></el-col>
            </el-row>
            <p class="meter-line"></p>
            <el-row :gutter="5">
                <el-col :span="8"><span>变频风机关联变量：</span><span>{{fmtStr_1_2(baseData.setting_vffan_var, '温差调速', '静压调速')}}</span></el-col>
                <el-col :span="8"><span>变频风机Ki系数：</span><span>{{baseData.setting_vffan_Ki}}</span></el-col>
                <el-col :span="8"><span>变频风机调节死区：</span><span>{{baseData.setting_vffan_dz/10 + 'Hz'}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="8"><span>变频风机调节输出周期：</span><span>{{baseData.setting_vffan_period + 's'}}</span></el-col>
                <el-col :span="8"><span>浮点新风阀初始开度设定：</span><span>{{baseData.setting_fau_init_aperture + '%'}}</span></el-col>
                <el-col :span="8"><span>浮点新风阀行程设定：</span><span>{{baseData.setting_fau_distance + 's'}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="6"><span>开机后风机输出延时设定：</span><span>{{baseData.setting_fan_delay + 's'}}</span></el-col>
            </el-row>
        </div>
    </cmp-drawer>
  </div>
</template>

<script>
import CmpDrawer from '@/components/CmpDrawer/CmpDrawer'
import { funFmtWKQParmas, funFmtOnlineStatus } from '@/utils/utils'
export default {
    name: "CmpFgDetail",
    props: ["show", "modelData"],
    data() {
        return {
        };
    },
    computed: {
        title() {
            return `${this.modelData.deviceType}：${this.modelData.deviceModel}`;
        },
        baseData() {
            return this.modelData._data || {}
        },
        faultMsgStr() {
            if(!this.modelData.faultMsg) return this.modelData.sysStatusResult
            return this.modelData.faultMsg.join('、')
        },
    },
    components: {
        CmpDrawer
    },
    created() {
        // console.log(this.modelData)
    },
    methods: {
        funFmtWKQParmas,
        // 关闭添加设备
        handleClose(bool) {
        this.$emit("update:show", false);
        },
        // 确认添加设备
        hanleSubmit(data) {
            this.$emit("update:show", false);
        },
        fmtStr_0_1(status, str1, str2) {
            if (status === 0) {
                return str1 || ''
            }
            if (status === 1) {
                return str2 || ''
            }
        },
        fmtStr_1_2(status, str1, str2) {
            if (status === 1) {
                return str1 || ''
            }
            if (status === 2) {
                return str2 || ''
            }
        },
        // 格式化在线状态
        fmtOnlineStatus(status) {
            return funFmtOnlineStatus(status);
        },
    },
    watch: {
        modelData(newVal) {
            // console.log(newVal);
        }
    }
};
</script>
<style lang='less' scoped>
    .scheme-detail-box{
        text-align: left;
        .meter-title{
            color: #333;
            font-weight: 400;
            font-size: 16px;
            line-height: 30px;
            margin: 15px 0;
            position: relative;
            padding-left: 15px;
            background-color: #e8e8e8;
            &:first-child{
                margin-top: 0;
            }
            &:before{
                content: "";
                position: absolute;
                left: 0;
                bottom: 0;
                height: 30px;
                width: 4px;
                background-color: @primary-color;
            }
        }
        .meter-line{
            font-size: 14px;
            height: 14px;
        }
    }
</style>